import {NgModule} from '@angular/core';
import {SharedModule} from "../../common/shared.module";
import {TemplatesComponent} from "./templates/templates.component";
import {StudioAdsComponent} from "./studio-ads/studio-ads.component";
import {HomeComponent} from "./home.component";
import {HomeOnboardingComponent} from "./home-onboarding/home-onboarding.component";
import {HomeShowcaseComponent} from "./home-showcase/home-showcase.component";
import {HomeInspireComponent} from "./home-inspire/home-inspire.component";
import {HomeInspireThumbComponent} from "./home-inspire/home-inspire-thumb.component";
import {HomeSectionComponent} from "./home-section/home-section.component";
import {NgxFlickingModule} from "@egjs/ngx-flicking";
import {SignageLibsModuleStudio, SignageLibsService} from '@signage/lib';

const declarations = [
    HomeComponent,
    StudioAdsComponent,
    TemplatesComponent,
    HomeOnboardingComponent,
    HomeShowcaseComponent,
    HomeInspireComponent,
    HomeInspireThumbComponent,
    HomeSectionComponent
];

@NgModule({
    imports: [
        SharedModule,
        NgxFlickingModule,
        SignageLibsModuleStudio
    ],
    declarations,
    exports: [],
    providers: [
        SignageLibsService
    ],
})

export class HomeModule {
}
